import { isApiErrorLike } from "@heraion/shared";

import type { TFn } from "./i18nTypes";

/** No server answered (a transport error, or the client's own timeout). */
const noAnswer = (err: unknown): boolean => !isApiErrorLike(err) || err.status === 0;

/** The sentence for a failed request: the needs-connection one when no
 *  server answered, else the generic one (a server's answer is not a
 *  connection problem). Never the raw `api_error_*` code. */
export const apiErrorText = (
  err: unknown,
  t: TFn,
  offlineKey = "inbox.actionErrorOffline",
  isOffline: (err: unknown) => boolean = noAnswer,
): string => t(isOffline(err) ? offlineKey : "mobile.account.actionFailed");
